import CONSTANTS from '../../constants'
import fetchWithAuthorizationHeader from '../../helper/fetchWithAuthorizationHeader'
import type { MongoDBEligibility } from '../../types/mongodb'

const { MONGODB_API_URL } = CONSTANTS

const getMongoDBEligibility = async (
	applicationID: string
): Promise<{ statusCode: number; body: MongoDBEligibility[] }> => {
	const query = new URLSearchParams({
		applicationID,
		eligibility: 'true'
	}).toString()
	const response = await fetchWithAuthorizationHeader(
		`${MONGODB_API_URL}?${query}`
	)
	const data = await response.json()
	if (!response.ok) {
		throw new Error(
			data.error?.message ||
				data.message ||
				'Unable to complete the MongoDB request.'
		)
	}
	if (!Array.isArray(data.body)) throw new Error('Invalid MongoDB response.')
	return data
}

export default getMongoDBEligibility
